import { fetchRequestWithTypes } from './index.js';

export const GET_USER_BILLING_SUMMARY_REQUEST = 'GET_USER_BILLING_SUMMARY_REQUEST';
export const GET_USER_BILLING_SUMMARY_SUCCESS = 'GET_USER_BILLING_SUMMARY_SUCCESS';
export const GET_USER_BILLING_SUMMARY_ERRORED = 'GET_USER_BILLING_SUMMARY_ERRORED';

export const getUserBillingSummary = () => {
	return fetchRequestWithTypes({
		types: [
			GET_USER_BILLING_SUMMARY_REQUEST,
			GET_USER_BILLING_SUMMARY_SUCCESS,
			GET_USER_BILLING_SUMMARY_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/users/:uuid/subscriptions/billingSummaries`,
		},
	});
};

export const GET_BILLING_FREQUENCY_OPTIONS_REQUEST =
	'GET_BILLING_FREQUENCY_OPTIONS_REQUEST';
export const GET_BILLING_FREQUENCY_OPTIONS_SUCCESS =
	'GET_BILLING_FREQUENCY_OPTIONS_SUCCESS';
export const GET_BILLING_FREQUENCY_OPTIONS_ERRORED =
	'GET_BILLING_FREQUENCY_OPTIONS_ERRORED';

export const getBillingFrequencyOptions = () => {
	return fetchRequestWithTypes({
		types: [
			GET_BILLING_FREQUENCY_OPTIONS_REQUEST,
			GET_BILLING_FREQUENCY_OPTIONS_SUCCESS,
			GET_BILLING_FREQUENCY_OPTIONS_ERRORED,
		],
		request: {
			method: 'GET',
			path: '/apis/customers/v1/users/:uuid/subscriptions/billingFrequencies',
		},
	});
};

export const PUT_BILLING_FREQUENCY_REQUEST = 'PUT_BILLING_FREQUENCY_REQUEST';
export const PUT_BILLING_FREQUENCY_SUCCESS = 'PUT_BILLING_FREQUENCY_SUCCESS';
export const PUT_BILLING_FREQUENCY_ERRORED = 'PUT_BILLING_FREQUENCY_ERRORED';

export const changeBillingFrequency = (frequency) => {
	return fetchRequestWithTypes({
		types: [
			PUT_BILLING_FREQUENCY_REQUEST,
			PUT_BILLING_FREQUENCY_SUCCESS,
			PUT_BILLING_FREQUENCY_ERRORED,
		],
		request: {
			method: 'PUT',
			path: '/apis/customers/v1/users/:uuid/subscriptions/billingFrequencies',
			body: { frequency },
		},
	});
};

export const GET_SUBSCRIPTION_STATUS_REQUEST = 'GET_SUBSCRIPTION_STATUS_REQUEST';
export const GET_SUBSCRIPTION_STATUS_SUCCESS = 'GET_SUBSCRIPTION_STATUS_SUCCESS';
export const GET_SUBSCRIPTION_STATUS_ERRORED = 'GET_SUBSCRIPTION_STATUS_ERRORED';

export const getSubscriptionStatus = () =>
	fetchRequestWithTypes({
		types: [
			GET_SUBSCRIPTION_STATUS_REQUEST,
			GET_SUBSCRIPTION_STATUS_SUCCESS,
			GET_SUBSCRIPTION_STATUS_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/users/:uuid/subscriptions/status`,
		},
	});

export const GET_USER_PAYMENT_METHODS_REQUEST = 'GET_USER_PAYMENT_METHODS_REQUEST';
export const GET_USER_PAYMENT_METHODS_SUCCESS = 'GET_USER_PAYMENT_METHODS_SUCCESS';
export const GET_USER_PAYMENT_METHODS_ERRORED = 'GET_USER_PAYMENT_METHODS_ERRORED';

export const getUserPaymentMethods = () =>
	fetchRequestWithTypes({
		types: [
			GET_USER_PAYMENT_METHODS_REQUEST,
			GET_USER_PAYMENT_METHODS_SUCCESS,
			GET_USER_PAYMENT_METHODS_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/users/:uuid/subscriptions/paymentMethods`,
		},
	});

export const GET_USER_SUBSCRIPTION_PLANS = 'GET_USER_SUBSCRIPTION_PLANS';
export const GET_USER_SUBSCRIPTION_PLANS_SUCCESS = 'GET_USER_SUBSCRIPTION_PLANS_SUCCESS';
export const GET_USER_SUBSCRIPTION_PLANS_ERRORED = 'GET_USER_SUBSCRIPTION_PLANS_ERRORED';

export const getUserSubscriptionPlans = () =>
	fetchRequestWithTypes({
		types: [
			GET_USER_SUBSCRIPTION_PLANS,
			GET_USER_SUBSCRIPTION_PLANS_SUCCESS,
			GET_USER_SUBSCRIPTION_PLANS_ERRORED,
		],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/subscriptions/plans`,
		},
	});

export const POST_USER_SUBSCRIPTION_REQUEST = 'POST_USER_SUBSCRIPTION_REQUEST';
export const POST_USER_SUBSCRIPTION_SUCCESS = 'POST_USER_SUBSCRIPTION_SUCCESS';
export const POST_USER_SUBSCRIPTION_ERROR = 'POST_USER_SUBSCRIPTION_ERROR';

export const postUserSubscription = (planId) =>
	fetchRequestWithTypes({
		types: [
			POST_USER_SUBSCRIPTION_REQUEST,
			POST_USER_SUBSCRIPTION_SUCCESS,
			POST_USER_SUBSCRIPTION_ERROR,
		],
		request: {
			method: 'POST',
			path: '/apis/customers/v1/subscriptions',
			body: { planId },
		},
	});

export const PUT_USER_PAYMENT_METHOD_PREFERENCE_REQUEST =
	'PUT_USER_PAYMENT_METHOD_PREFERENCE_REQUEST';
export const PUT_USER_PAYMENT_METHOD_PREFERENCE_SUCCESS =
	'PUT_USER_PAYMENT_METHOD_PREFERENCE_SUCCESS';
export const PUT_USER_PAYMENT_METHOD_PREFERENCE_ERRORED =
	'PUT_USER_PAYMENT_METHOD_PREFERENCE_ERRORED';

export const putUserPaymentMethodPreference = (id, type) =>
	fetchRequestWithTypes({
		types: [
			PUT_USER_PAYMENT_METHOD_PREFERENCE_REQUEST,
			PUT_USER_PAYMENT_METHOD_PREFERENCE_SUCCESS,
			PUT_USER_PAYMENT_METHOD_PREFERENCE_ERRORED,
		],
		request: {
			method: 'PUT',
			path: `/apis/customers/v1/users/:uuid/subscriptions/paymentMethodPreferences`,
			body: {
				paymentMethod: {
					id,
					type,
				},
			},
		},
	});
